var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('Loading',{staticClass:"center"}):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('MainWeather'),_c('ForecastWeather')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }